import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6 } from "styled-components";
const _excluded = ["style", "className", "title", "subtitle", "tertiaryText", "renderIcons", "renderActions"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';
const Details = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      title,
      subtitle,
      tertiaryText,
      renderIcons,
      renderActions
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!title && !subtitle && !tertiaryText && !renderIcons && !renderActions) {
    return null;
  }
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({}, props, {
    ref: ref,
    className: className,
    $_css: [{
      padding: theme.spacing.XS
    }, style]
  }), (title || renderActions) && /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: [{
      height: 16,
      display: 'flex',
      justifyContent: 'space-between'
    }, theme.typography.bodySmallBold]
  }, /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: theme.typography.ellipsis
  }, /*#__PURE__*/React.createElement(OverflowTooltip, null, title)), renderActions === null || renderActions === void 0 ? void 0 : renderActions()), subtitle && /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css4: [{
      marginTop: 6,
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.typography.bodySmall, theme.typography.ellipsis]
  }, /*#__PURE__*/React.createElement(OverflowTooltip, null, subtitle)), (tertiaryText || renderIcons) && /*#__PURE__*/React.createElement(_StyledDiv5, {
    $_css5: [{
      marginTop: theme.spacing.XS,
      display: 'flex',
      justifyContent: 'space-between',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.typography.bodySmall]
  }, /*#__PURE__*/React.createElement(_StyledDiv6, {
    $_css6: theme.typography.ellipsis
  }, /*#__PURE__*/React.createElement(OverflowTooltip, null, tertiaryText)), renderIcons === null || renderIcons === void 0 ? void 0 : renderIcons()));
});
Details.displayName = 'Details';
Details.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Tile title */
  title: PropTypes.string,
  /** Tile subtitle */
  subtitle: PropTypes.string,
  /** Tile tertiary text */
  tertiaryText: PropTypes.string,
  /** Render icons function */
  renderIcons: PropTypes.func,
  /** Render actions.  Generally used to render a three dot ActionButton */
  renderActions: PropTypes.func
};
export default Details;
var _StyledDiv = _styled("div")`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div")`${p => p.$_css2}`;
var _StyledDiv3 = _styled3("div")`${p => p.$_css3}`;
var _StyledDiv4 = _styled4("div")`${p => p.$_css4}`;
var _StyledDiv5 = _styled5("div")`${p => p.$_css5}`;
var _StyledDiv6 = _styled6("div").withConfig({
  displayName: "Details___StyledDiv6",
  componentId: "sc-3tl304-0"
})(["", ""], p => p.$_css6);
//# sourceMappingURL=Details.js.map